module.exports = __webpack_public_path__ + "static/img/son10.9a4c7b6c.png";